export default {
  SET_COLORS: (state, data) => {
    state.colors = data;
  },
  SET_COLOR: (state, data) => {
    state.color = data;
  },
};
